import React from "react";
import type { Descendant } from "slate";
import type { RenderElementProps, RenderLeafProps } from "slate-react";

import { TextBlockRenderOptions } from "./types";

interface TextBlockRenderContextValue {
  editing: boolean;
  renderElement: (props: RenderElementProps) => JSX.Element;
  renderLeaf: (props: RenderLeafProps) => JSX.Element;
  renderTextBlock: (
    id: string,
    initialValue: Descendant[],
    options?: TextBlockRenderOptions
  ) => JSX.Element;
}

const TextBlockRenderContext = React.createContext<TextBlockRenderContextValue>({
  editing: false,
  renderElement: () => <></>,
  renderLeaf: () => <></>,
  renderTextBlock: () => <></>
});

interface TextBlockRenderProviderProps {
  children: React.ReactNode;
  editing: boolean;
  renderElement: (props: RenderElementProps) => React.JSX.Element;
  renderLeaf: (props: RenderLeafProps) => React.JSX.Element;
  renderTextBlock: TextBlockRenderContextValue["renderTextBlock"];
}

export const TextBlockRenderProvider: React.FC<TextBlockRenderProviderProps> = (providerProps) => {
  const { editing, renderElement, renderLeaf, renderTextBlock } = providerProps;

  return (
    <TextBlockRenderContext.Provider
      value={{ editing, renderElement, renderLeaf, renderTextBlock }}
    >
      {providerProps.children}
    </TextBlockRenderContext.Provider>
  );
};

export const useTextBlockRendering = () => {
  return React.useContext(TextBlockRenderContext);
};
